"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.block = {
    display: 'block'
};
exports.none = {
    display: 'none'
};
exports.inlineBlock = {
    display: 'inline-block'
};
exports.invisible = {
    visibility: 'hidden'
};
